import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { ProfessoresQuery, ProfessoresQueryVariables } from './__generated__/ProfessoresQuery';

const PROFESSORES_QUERY = gql`
  query ProfessoresQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    professores(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_professor
      id_usuario
      dsc_nome_professor
      dsc_email
      dsc_email2
      dsc_email3
      dsc_num_telefone
      dsc_num_telefone2
      dsc_titulacao
      flag_casa
      dsc_bio
      dsc_link_linkedin
      dsc_link_twitter
      dsc_link_facebook
      dsc_link_lattes
      dsc_link_instagram
    }
  }
`;

const useProfessoresQuery = (variables: ProfessoresQueryVariables) => {
  return useQuery<ProfessoresQuery, ProfessoresQueryVariables>(PROFESSORES_QUERY, {
    variables,
  });
};

const useProfessoresLazyQuery = () => {
  return useLazyQuery<ProfessoresQuery, ProfessoresQueryVariables>(PROFESSORES_QUERY);
};

export { useProfessoresQuery, useProfessoresLazyQuery };
